module.exports = __webpack_public_path__ + "static/icon-payment-unionpay-e7cec5af754a18cc7e3d6906a0dbb733.svg";